<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div class="d-flex flex-column" style="height: 100%;">
      <div class="flex-grow-1">
        <div
          style="color: var(--primary-color-blue);"
          class="text-center display font-weight-bold"
          :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
        >
          {{ $t("recover.title") }}
          <p style="color: var(--primary-color-blue);" class="text-center font-weight-light subtitle-2 pt-2">
            {{ $t("recover.subtitle") }}
          </p>
        </div>
        <div class="mt-13 mx-10">
          <v-col style="color: var(--primary-color-blue);" class="py-5" v-for="(field, i) in fields" :key="i">
            <v-row style="font-size: 14px; font-weight: 300;">
              {{ $t("recover." + i) }}*
            </v-row>
            <v-row align="center" justify="space-around">
              <v-text-field
                flat
                solo
                hide-details
                single-line
                v-model="fields[i]"
                class="input-custom"
              >
              </v-text-field>
            </v-row>
          </v-col>
          <span v-if="formErrors.email" class="red--text">{{
            formErrors.email
          }}</span>
        </div>
    
        <div class="mt-13 mx-10">
          <v-btn
            class="px-13 py-7 mb-5 w-100"
            style="color: var(--text-over-secondary) !important; background: var(--primary-color-blue); border-radius: 16px !important;"
            rounded
            outlined
            outlined-border-width="7"
            :loading="sentRequest"
            @click="recover()"
          >
            {{ $t("recover.title") }}
          </v-btn>
          <p @click="$router.push({ name: routeNames.LOGIN })" class="text-center" style="color: var(--primary-color-blue); text-decoration: underline; font-weight: 300; font-size: 14px;">
            {{ $t("recover.go_back") }}
          </p>
        </div>
      </div>
      <BottomBar :logged="false"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import RedirectHandler from "@/mixins/RedirectHandler";
import errorManager from "../services/error.manager";
import BottomBar from "@/components/BottomBar";

export default {
  name: "SetPasswordView",
  props: ["routeNames", "auth"],
  mixins: [RedirectHandler],
  data() {
    return {
      fields: {
        email: null,
      },
      sentRequest: false,
      formErrors: {},
    };
  },
  methods: {
    recover() {
      this.formErrors = {};
      if (!this.fields.email) {
        this.formErrors.email = this.$t("error.bad_request.any.required");
        return;
      }
      const context = this;
      this.sentRequest = true;
      this.auth
        .recover(context, this.fields.email)
        .then(() => {
          const action = "recover";
          const viewData = {
            primary_text: {
              vicon: "check_circle",
              text: "recover.email_send",
            },
            secondary_text: "recover.email_send_subtitle",
            redirectTo: "LOGIN",
          };

          this.successSignUpRedirect(action, viewData, true);
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
  },
  components: {
    Layout,
    BottomBar
  },
};
</script>

<style>
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
